<template>
  <div>
    <filter-swapper id="tariffs" :buttons="buttons" :controlHeightButtons="controlHeight">
      <template #slot1>
        <form-render
          :key="keyFormRender"
          :fields="fields"
          :form.sync="form"
          @send="buttonFind"
          class="px-0"
          containerButtonsClass="col-sm-12 col-md-12 col-lg-3 mt-2 mb-4 buttons-rates-costs"
        >
          <template #buttons>
            <b-button variant="warning" :disabled="buttonSend.disabled || loading.pricesMixCoverages || loading.rates" @click="buttonFind">
              <feather-icon v-if="!loading.pricesMixCoverages && !loading.rates" icon="SearchIcon" />
              <span v-if="loading.pricesMixCoverages || loading.rates"><b-spinner small /> </span>
            </b-button>
            <b-button
              variant="outline-light"
              v-b-tooltip.hover
              title="Limpiar filtros"
              class="ml-2"
              @click="cleanFilter"
            >
              <feather-icon icon="RefreshCwIcon" />
            </b-button>
          </template>
        </form-render>
        <div>
          <div class="msj-info" v-if="showTable">
            <li>
              Para obtener toda la información de las tarifas de un lugar de origen, puede descargarla presionando el
              botón "Exportar servicio {{ serviceSelected.name }}"
            </li>
          </div>
        </div>
        <b-alert show v-if="showTable" class="mt-1 alert-msg">
          <div class="alert-body d-flex align-items-center">
            <feather-icon class="text-warning" icon="AlertTriangleIcon" size="28"/>
            <ul class="mb-0">
              <li>
                Los valores son netos, <span class="highlight">no incluyen {{form.country.code === 'PE' ? 'IGV' : 'IVA'}}.</span>
              </li>
              <li>
                El cobro se basará en el <span class="highlight">mayor valor</span> entre peso físico y volumétrico.
              </li>
              <li>Las tarifas podrán <span class="highlight">reajustarse</span>, según lo establezca el <span class="highlight">operador</span>.</li>
            </ul>
          </div>
        </b-alert>
        <b-form-group class="mt-2 mb-2 form-group-tariffs" v-if="showTable">
          <b-form-radio-group id="rates-costs-radio" @change="changeRatesCostsRadio" v-model="ratesCostsRadio">
            <template>
              <div class="d-flex">
                <div v-for="(option, index) in ratesCostsRadioOptions" :key="index">
                  <b-form-radio :value="option">{{option}}</b-form-radio>
                    <feather-icon v-if="rowsAdditionalCharges.length && option === 'Cobros adicionales'" class="alertCircle" icon="AlertCircleIcon"></feather-icon>
                </div>
              </div>
            </template>
          </b-form-radio-group>
          <span
            :title="$t(buttonSend.disabled ? 'Debe completar el formulario' : (rows.length ? 'Descargar archivo' : 'No hay datos para descargar'))"
            v-b-tooltip.bottom.hover
            class="text-right button-with-alert"
            v-if="ratesCostsRadio !== 'Recaudos'"
          >
            <b-button
              variant="success"
              @click="exportExcel"
              class="ml-2"
              :disabled="!showTable || loading.donwLoadExcel || rows.length === 0"
              v-if="showTable"
            >
              <feather-icon v-if="!loading.donwLoadExcel" icon="DownloadIcon" />
              <b-spinner v-if="loading.donwLoadExcel" small />
              <span class="ml-1">
                Exportar servicio {{ serviceSelected.name }}
              </span>
            </b-button>
          </span>
        </b-form-group>
        <b-alert show v-if="showTable && ratesCostsRadio === 'Cobros adicionales'" class="mt-1 alert-msg">
            <div class="alert-body d-flex align-items-center">
              <feather-icon class="text-warning" icon="AlertTriangleIcon" size="28"/>
              <ul class="mb-0">
                <li>
                  La tarifa filtrada presenta los <span class="highlight">cobros adicionales</span> mostrados en la tabla.
                </li>
              </ul>
            </div>
        </b-alert>
        <ul v-if="showTable && form.categoryService && !isExpress && ratesCostsRadio !== 'Cobros adicionales' && ratesCostsRadio !== 'Recaudos'" class="navbar-nav mb-1">
          <li>
            <div style="justify-self: end;" class="col-sm-10 col-md-10 col-lg-5 float-right">
              <div v-if="showTable && form.categoryService && !isExpress && ratesCostsRadio !== 'Flete' && ratesCostsRadio !== 'Cobros adicionales'">
                <label v-if="form && form.country && form.country.code !== 'MX'"><span>Nombre del destino</span></label>
                <div class="d-flex justify-content-end">
                  <form-render v-if="form && form.country && form.country.code === 'MX'" :key="keyFormRenderDestination" :fields="destinationFields" :form.sync="destinationForm" class="col-sm-3 col-md-10 col-lg-10 pr-0 input-destination-search"></form-render>
                  <b-form-input  v-if="form && form.country && form.country.code !== 'MX'" class="border-secondary input-destination-search" v-model="seekerValue" placeholder="ingrese el nombre del Destino" cleareable ></b-form-input>
                  <b-input-group-append class="d-flex align-self-end">
                    <b-button
                      variant="outline-secondary"
                      v-b-tooltip.hover
                      title="Buscar"
                      @click="searchSpecifically"
                      :disabled="seekerValue.length < 3"
                      class="button-destination-search"
                    >
                      <feather-icon icon="SearchIcon"
                    /></b-button>
                    <b-button variant="outline-secondary" v-b-tooltip.hover title="Limpiar" @click="cleanSearch" class="button-destination-search-close">
                      <feather-icon icon="XIcon"
                    /></b-button>
                  </b-input-group-append>
                </div>
                <span
                  v-if="seekerValue.length < 3 && seekerValue.length > 0"
                  class="text-danger position-absolute bg-white"
                  >{{ $t('msg-nchars', { key: 3 }) }}
                </span>
              </div>
            </div>
          </li>
        </ul>
        <div class="d-flex" v-if="showTable && ratesCostsRadio !== 'Recaudos'">
          <b-tabs align="left" class="tab-primary" v-model="tabIndex">
            <b-tab v-for="(services, index) in serviceTypes" :key="index">
              <template #title>
                <div class="text-center">
                  <span v-html="services.name"></span>
                </div>
              </template>
            </b-tab>
          </b-tabs>

          <div v-if="ratesCostsRadio === 'Tarifas'" class="ml-auto text-primary mt-1 font-weight-bold d-flex">
            <v-date-picker v-model="form.date" :min-date="minSelectableDate" :max-date="new Date()" @input="handleDateSelect">
              <template v-slot="{ inputValue, inputEvents }">
                <span :value="inputValue" v-on="inputEvents" >
                  Tarifas por fecha
                </span>
                <feather-icon icon="CalendarIcon" size="16"/>
              </template>
            </v-date-picker>
          </div>

          <!-- <a class="ml-auto text-primary mt-1 font-weight-bold" @click="openModal">
            <span class="icon-class-tariff"><feather-icon icon="ClockIcon" class="iconClass" size="16" /></span>
            <span>Historial de tarifas</span>
          </a> -->
        </div>
        <div v-if="ratesCostsRadio === 'Recaudos' && showTable" class="mb-1">
          <li>
            <span class="text-services-collections">Servicios a los que aplica: </span>{{ formattedLimitServices }}
          </li>
        </div>
      </template>
    </filter-swapper>
    <table-render
      v-if="
        showTable &&
        !loading.pricesMixCoverages &&
        !loading.rates &&
        form.categoryService &&
        !isExpress &&
        ratesCostsRadio !== 'Cobros adicionales'
      "
      :schema.sync="schema"
      :rows="rows"
      :stickyHeader="`calc(100vh - 2.5rem)`"
      id="rates-costs-table"
      :tableClass="'with-scroll'"
    >
    </table-render>
    <pagination
      v-if="
        showTable &&
        !loading.pricesMixCoverages &&
        !loading.rates &&
        form.categoryService &&
        !isExpress &&
        form.country.code !== 'MX' &&
        ratesCostsRadio !== 'Recaudos' &&
        ratesCostsRadio !== 'Cobros adicionales'
      "
      :pagination="pagination"
      :showSize="true"
    />
    <a @click="goToCatalog" class="lnk lnk-primary link-to-catalog mt-2" v-if="ratesCostsRadio === 'Recaudos' && showTable && redirectCatalogServicesMethod"> <img :src="require(`@/assets/images/icons/couriers-catalog-icons/icon-hand-right.svg`)" /><span class="text-link-catalog">Ver condiciones en el catálogo</span></a>
    <CoveragesKmList
      :rows="rows"
      v-if="showTable && !loading.pricesMixCoverages && !loading.rates && form.categoryService && !!isExpress && ratesCostsRadio !== 'Cobros adicionales'"
    ></CoveragesKmList>
    <AdditionalCharges
      :rows="rowsAdditionalCharges"
      v-if=" showTable && ratesCostsRadio === 'Cobros adicionales'"
    ></AdditionalCharges>
    <div class="table-render-skeleton" v-if="loading.pricesMixCoverages || loading.rates">
      <b-skeleton-table :rows="15" :columns="schema.length || 10" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AdditionalCharges from './components/AdditionalCharges.vue'
import CoveragesKmList from './components/CoveragesKmList.vue'
import BaseServices from '@/store/services/index'
import { getMinDate, setPlaces, getCountrySchema, getWeightSchema, sortArrayNumbers, formatDate_YYYY_MM_DD, buildSchemaByCountry } from '@/views/modules/pricing/pricing.helpers'

export default {
  name: 'tariffs',
  props: {
    initData: {
      type: Object,
      default: () => ({})
    },
    getCarrier: {
      type: Function,
      default: () => {}
    }
  },
  components: { CoveragesKmList, AdditionalCharges },
  data() {
    return {
      rows: [],
      rowsAdditionalCharges: [],
      schema: [],
      buttons: [],
      controlHeight: { class: 'row mb-2 spacing-label-field' },
      keyFormRender: 0,
      fields: [],
      form: {date: new Date()},
      keyFormRenderDestination: 0,
      destinationFields: [
        { fieldType: 'FieldSelect', name: 'destinationPlace', label: 'Nombre del destino', containerClass: 'col-12', useSkeleton: false, change: this.changeDestinationPlace, clearable: false, searchOnType: { fx: this.setPlaces, nChars: 3, debounce: 600 } }
      ],
      destinationForm: {},
      buttonSend: {
        icon: 'SearchIcon',
        title: 'Buscar',
        color: 'warning',
        disabled: true
      },
      fieldSkipLine: {
        name: 'line',
        useSkeleton: true,
        skipLine: true,
        containerClass: 'col-12'
      },
      showTable: false,
      serviceTypes: [],
      rateServiceId: '',
      tabIndex: 0,
      filterRates: [],
      ratesCostsRadio: 'Tarifas',
      ratesCostsRadioOptions: ['Tarifas', 'Cobros adicionales', 'Recaudos'],
      serviceIndex: 0,
      pricesOrCosts: 'pricesMixCoverages',
      serviceSelected: null,
      rateId: null,
      baseService: new BaseServices(this),
      seekerValue: '',
      arrayCurrentKgs: [],
      isExpress: false,
      loading: {
        rates: false,
        pricesMixCoverages: false,
        donwLoadExcel: false
      },
      pagination: {
        page: 1,
        total: 0,
        limit: 20
      },
      paramPage: 1,
      paramPageSize: 20,
      minSelectableDate: getMinDate()

    }
  },
  computed: {
    ...mapGetters({
      places: 'getPlacesFullLevelSearchByCountry',
      carriers: 'getCarriersByCountryPlace',
      categoryService: 'getServiceTypesByCountryCarrierPlace',
      services: 'getServiceByCountryPlaceCarrierServiceType',
      rates: 'getRatesByCarrierService',
      pricesMixCoverages: 'getPricesMixCoverages',
      generalLoading: 'getLoading',
      additionalChargesByRateId: 'getAdditionalChargesByRateId',
      collectionOnDelivery: 'getCollectionOnDelivery'
    }),

    redirectCatalogServicesMethod() {
      if (
        this.collectionOnDelivery &&
        this.collectionOnDelivery.rows &&
        this.collectionOnDelivery.rows[0] &&
        Array.isArray(this.collectionOnDelivery.rows[0].limit_services)
      ) {
        // Filtrar los servicios donde show_in_catalag es true
        const visibleServices = this.collectionOnDelivery.rows[0].limit_services
          .filter(service => service.show_in_catalog)
          .map(service => service.name) // Obtener solo los nombres
        return visibleServices.length > 0
      }
      return false
    },

    formattedLimitServices() {
      if (
        this.collectionOnDelivery &&
        this.collectionOnDelivery.rows &&
        this.collectionOnDelivery.rows[0] &&
        Array.isArray(this.collectionOnDelivery.rows[0].limit_services)
      ) {
        // Filtrar los servicios donde show_in_catalag es true
        const visibleServices = this.collectionOnDelivery.rows[0].limit_services
          .map(service => service.name) // Obtener solo los nombres

        // Unir los nombres en un string separado por comas
        return visibleServices.length > 0 ? visibleServices.join(', ') : 'No hay servicios disponibles aqui'
      }
      return 'No hay servicios disponibles'
    }
  },
  watch: {
    carriers() {
      this.setCarriers()
    },
    categoryService() {
      this.setCategoryService()
    },
    services() {
      this.setServiceRatesQuoter()
    },
    rates() {
      this.ratesCostsRadioOptions = ['Tarifas', 'Cobros adicionales']
      if (this.form.country.code.toLocaleLowerCase() === 'co' || this.form.country.code.toLocaleLowerCase() === 'pe' || this.form.country.code.toLocaleLowerCase() === 'mx') {
        this.ratesCostsRadioOptions.push('Recaudos')
      }
      this.setRatesRatesQuoter()
    },
    pricesMixCoverages() {
      this.setPricesRatesQuoter()
    },
    generalLoading: {
      handler() {
        this.loading.rates = !!this.generalLoading.getRatesByCarrierService
        this.loading.pricesMixCoverages = !!this.generalLoading.getPricesMixCoverages
        this.loading.donwLoadExcel = !!this.generalLoading.getFileMixCoverages
      }
    },
    tabIndex(val) {
      this.serviceIndex = val
      this.serviceSelected = this.services.rows[val]
      const params = {
        carrier_id: this.form.carriers.id,
        service_id: this.services.rows[val]?.id
      }
      const queryParams = {}
      this.getServices('getRatesByCarrierService', params, queryParams)
    },
    'pagination.page'() {
      this.paramPage = this.pagination.page
      this.getCoverages()
    },
    'pagination.limit'() {
      this.paramPageSize = this.pagination.limit
      this.getCoverages()
    },
    rateId(val) {
      const rate = this.filterRates.filter((el) => val === el.id)
      rate[0]?.rate_type === 'km' ? (this.isExpress = true) : (this.isExpress = false)
    },
    additionalChargesByRateId() {
      this.rowsAdditionalCharges = this.additionalChargesByRateId.rows
      this.showTable = true
    },
    collectionOnDelivery() {
      this.setCollectionOnDelivery()
    }
  },
  mounted() {
    this.setInitialData()
  },
  methods: {
    setInitialData() {
      this.fields = [
        { fieldType: 'FieldSelect', useSkeleton: true, useLabel: true, name: 'country', disabled: false, label: 'País', validation: 'required', containerClass: 'col-12 col-md-4 col-lg-3 container-info', addFlags: true, sort: true },
        this.fieldSkipLine,
        { fieldType: 'FieldSelect', useSkeleton: true, useLabel: true, name: 'places', label: 'Origen', validation: 'required', containerClass: 'col-12 col-md-4 col-lg-3 container-info', change: this.changePlaces, dependency: 'country', clearable: true, searchOnType: { fx: this.setPlaces, nChars: 3, debounce: 600, allowSearchAsValue: false, persistSearch: true }},
        { fieldType: 'FieldSelect', useSkeleton: true, useLabel: true, name: 'carriers', label: 'Courier', validation: 'required', containerClass: 'col-12 col-md-4 col-lg-3 container-info', change: this.changeCarriers, dependency: 'places', sort: true },
        { fieldType: 'FieldSelect', useSkeleton: true, useLabel: true, name: 'categoryService', label: 'Categoría de Servicio', validation: 'required', containerClass: 'col-12 col-md-4 col-lg-3 container-info', change: this.changeCategoryService, dependency: 'carriers', sort: true }
      ]
      this.form.idSeller = this.initData.mySession.global_scope.organization_id[0]
      this.schema = []
      this.setCountries()
    },
    getAdditionalCharges() {
      const params = this.getParams()
      this.getServices('getAdditionalChargesByRateId', params.params, params.queryParams)
    },
    getCoverages() {
      this.serviceSelected = this.services.rows[this.serviceIndex]
      if (this.ratesCostsRadio === 'Tarifas' || this.ratesCostsRadio === 'Tarifas Generales' || this.ratesCostsRadio === 'Tarifas Preferentes') this.getPrices()
      if (this.ratesCostsRadio === 'Cobros adicionales') this.getAdditionalCharges()
      if (this.ratesCostsRadio === 'Recaudos') this.getRecaudos()
    },
    getPrices() {
      this.pricesOrCosts = 'pricesMixCoverages'
      const params = this.getParams()
      this.getServices('getPricesMixCoverages', params.params, params.queryParams)
    },
    getRecaudos() {
      this.showTable = true
      const params = {
        country_id: this.form.country.id
      }
      const queryParams = {}
      if (this.form.carriers) queryParams.carrier_ids = this.form.carriers.id
      this.$store.dispatch('fetchService', { name: 'getCollectionOnDelivery', params, queryParams })
    },
    getParams() {
      const params = {
        carrier_id: this.form.carriers.id,
        service_id: this.services.rows[this.serviceIndex]?.id,
        rate_id: this.rateId,
        place_id: this.form.places.id
      }
      const queryParams = {
        weightIntervalsLimit: this.form.categoryService.type === 'express' ? 10 : 6,
        search: this.seekerValue,
        page: this.paramPage,
        page_size: this.paramPageSize
      }
      if (this.form.idSeller) queryParams.organization_id = this.form.idSeller
      if (this.form.date) queryParams.date = formatDate_YYYY_MM_DD(this.form.date)
      return { params, queryParams }
    },
    changePlaces(name, value) {
      this.$emit('getCarrier', {})
      this.buttonSend.disabled = true
      this.seekerValue = ''
      this.showTable = false
      this.form.categoryService = null
      this.form.carriers = null
      if (value) {
        const params = {
          country_id: this.form.country.id,
          place_id: value.id
        }
        const queryParams = {}
        if (this.form.idSeller) queryParams.organization_id = this.form.idSeller
        this.fields.forEach((el) => {
          if (el.name !== 'country' && el.name !== 'places') this.setSkeletonField(el.name, true)
        })
        this.getServices('getCarriersByCountryPlace', params, queryParams)
      } else {
        this.cleanPlaces(['places', 'carriers', 'categoryService'])
      }
    },
    changeDestinationPlace(name, value) {
      if (value) this.seekerValue = value.code
      else this.seekerValue = ''
    },
    changeCarriers(name, value) {
      this.seekerValue = ''
      this.$emit('getCarrier', {})
      this.buttonSend.disabled = true
      this.showTable = false
      const params = {
        country_id: this.form.country.id,
        place_id: this.form.places.id,
        carrier_id: value?.id
      }
      const queryParams = {}
      if (this.form.idSeller) queryParams.organization_id = this.form.idSeller
      if (value?.id) {
        this.setSkeletonField('categoryService', true)
        this.$store.dispatch('fetchService', { name: 'getServiceTypesByCountryCarrierPlace', params, queryParams })
      }
      this.form = {
        ...this.form,
        categoryService: null
      }
    },
    changeCategoryService(name, value) {
      this.seekerValue = ''
      this.rateId = null
      this.showTable = false
      const params = {
        country_id: this.form.country.id,
        place_id: this.form.places.id,
        carrier_id: this.form.carriers.id,
        service_type_id: value.id
      }
      const queryParams = {}
      if (this.form.idSeller) queryParams.organization_id = this.form.idSeller
      if (value?.code) {
        this.$store.dispatch('fetchService', { name: 'getServiceByCountryPlaceCarrierServiceType', params, queryParams })
        this.isExpress = value.type === 'express'
      } else {
        this.buttonSend.disabled = true
      }
    },
    changeSchema(data) {
      if (data.length) {
        this.arrayCurrentKgs = sortArrayNumbers(Object.keys(data[0].weight_intervals))
        this.schema = buildSchemaByCountry(this.form.country.id, this.arrayCurrentKgs)
      }
    },
    changeRatesCostsRadio(name) {
      this.ratesCostsRadio = name
      this.schema = []
      this.setRatesRatesQuoter()
    },
    setCountries() {
      const indexCountry = this.fields.findIndex((el) => el.name === 'country')
      this.fields[indexCountry].disabled = true
      this.fields[indexCountry].clearable = false
      this.form.country = this.initData.mySession.country
      this.fields.forEach((el) => this.setSkeletonField(el.name, false))
    },
    async setPlaces(value) {
      return await setPlaces({ value, form: this.form, baseService: this.baseService })
    },
    setCarriers() {
      // Eliminar objetos repetidos
      const rows = []
      // Paso 1: Iterar sobre el array original
      this.carriers.rows.forEach(el => {
        // Paso 2: Verificar si el objeto ya existe en el nuevo array
        let exist = false
        rows.forEach(item => {
          if (JSON.stringify(item) === JSON.stringify(el)) {
            exist = true
          }
        })
        // Paso 3: Si el objeto no existe, agregarlo al nuevo array
        if (!exist) {
          rows.push(el)
        }
      })
      const inputs = ['carriers', 'categoryService']
      inputs.forEach((el) => this.setSkeletonField(el, true))
      const index = this.fields.findIndex((el) => el.name === 'carriers')
      this.fields[index].options = rows
      setTimeout(() => inputs.forEach((el) => this.setSkeletonField(el, false)), 100)
    },
    setCategoryService() {
      const index = this.fields.findIndex((el) => el.name === 'categoryService')
      this.fields[index].options = this.categoryService.rows
      this.setSkeletonField('categoryService', false)
    },
    setServiceRatesQuoter() {
      if (this.services.rows.length) {
        this.serviceTypes = this.services.rows
        this.buttonSend.disabled = false
      }
    },
    setRatesRatesQuoter() {
      this.filterRates = this.rates.rows
      this.rateServiceId = this.filterRates.find((el) => el.type === 'current') || this.filterRates[0]
      this.rateId = this.filterRates?.some((el) => el.id === this.rateId) ? this.rateId : this.rateServiceId.id
      if (this.ratesCostsRadioOptions.includes(this.ratesCostsRadio)) {
        this.getCoverages()
      } else {
        this.ratesCostsRadio = 'Tarifas'
      }
    },
    setSkeletonField(name, bool) {
      const index = this.fields.findIndex((el) => el.name === name)
      if (index !== -1) {
        this.fields[index].useSlot = bool
        this.fields[index].useSkeleton = bool
        this.fields[index].useLabel = bool
      }
    },
    setPricesRatesQuoter() {
      this.rows = []
      let currentId = 0
      if (!this.isExpress) this.changeSchema(this.pricesMixCoverages.rows)
      this.paramPage = this.pricesMixCoverages.meta?.current_page || 1
      this.pagination.total = this.pricesMixCoverages.meta?.total_rows || 0
      if (this.form.country.code === 'CO') {
        const indexFreight = this.schema.findIndex((el) => el.key === 'freight_minimum_cost')
        const indexPercentage = this.schema.findIndex((el) => el.key === 'freight_percentage_cost')
        const freight_minimum_cost = {
          label: 'Flete de manejo minimo',
          key: 'freight_minimum_cost',
          class: ['text-right']
        }
        const freight_percentage_cost = {
          label: '% flete de manejo',
          key: 'freight_percentage_cost',
          class: ['text-center']
        }
        if (indexFreight === -1) this.schema.splice(3, 0, freight_minimum_cost)
        if (indexPercentage === -1) this.schema.splice(4, 0, freight_percentage_cost)
      } else {
        const indexFreight = this.schema.findIndex((el) => el.key === 'freight_minimum_cost')
        if (indexFreight !== -1) this.schema.splice([indexFreight], 1)
        const indexPercentage = this.schema.findIndex((el) => el.key === 'freight_percentage_cost')
        if (indexPercentage !== -1) this.schema.splice([indexPercentage], 1)
      }
      if (this.isExpress) {
        [this.pricesMixCoverages.rows.weight_intervals].map((el) => {
          const keysRows = Object.keys(el)
          keysRows.map((key) => {
            this.pricesMixCoverages.rows.weight_intervals[key] = this.pricesMixCoverages.rows.weight_intervals[key].fp
          })
        })
        this.rows = [this.pricesMixCoverages.rows]
        if (this.rows.length) this.rows[0].weight_intervals.price = 'Precio'
      } else {
        this.pricesMixCoverages.rows.map(({ weight_intervals, freight_percentage_cost, dest_place_name, ...rest }) => {
          const percentage = `${freight_percentage_cost} %`
          const levelsPlace = dest_place_name.split(', ')
          let level0MX = ''
          if (this.form.country.id === 2) level0MX = levelsPlace[0].replace('CP ', '')
          const row = {
            id: currentId,
            ...rest,
            freight_percentage_cost: percentage,
            level0: level0MX || levelsPlace[0],
            level1: levelsPlace[1],
            level2: levelsPlace[2],
            level3: levelsPlace[3]
          }
          this.arrayCurrentKgs.forEach((el) => {
            row[`${el}kg`] = weight_intervals[el]?.fp
          })
          this.rows.push(row)
          currentId++
        })
      }
      this.showTable = true
    },
    setCollectionOnDelivery() {
      this.rows = this.collectionOnDelivery.rows
      this.setSchemaCollectionOnDelivery()
    },
    setSchemaCollectionOnDelivery() {
      this.schema = [
        { key: 'min_val', label: 'Valor mínimo recaudo', class:'text-left'},
        { key: 'max_val', label: 'Valor máximo recaudo', class:'text-left'},
        { key: 'percentage_cash', label: 'Recaudo contra entrega efectivo', class:'text-left'},
        { key: 'cash', label: 'Mínimo pago por recaudo efectivo', class:'text-left' },
        { key: 'percentage_instant_payment', label: 'Recaudo contra entrega débito/prepago/PSE', class:'text-left'},
        { key: 'instant_payment', label: 'Mínimo pago por recaudo débito/prepago/PSE', class:'text-left' },
        { key: 'percentage_credit_card', label: 'Recaudo contra entrega crédito', class:'text-left' },
        { key: 'credit_card', label: 'Mínimo pago por recaudo crédito', class:'text-left' }
      ]
    },
    cleanPlaces(fieldsArray) {
      fieldsArray.forEach((el) => this.setSkeletonField(el, true))
      setTimeout(() => {
        fieldsArray.forEach((el) => this.setSkeletonField(el, false))
      }, 200)
    },
    buttonFind() {
      this.$emit('getCarrier', this.form.carriers)
      const params = {
        carrier_id: this.form.carriers?.id,
        service_id: this.services.rows[this.serviceIndex]?.id
      }
      const queryParams = {}
      if (this.form.idSeller) queryParams.organization_id = this.form.idSeller
      this.getServices('getRatesByCarrierService', params, queryParams)
    },
    searchSpecifically() {
      this.pagination.page === 1 ? this.getCoverages() : (this.pagination.page = 1)
    },
    exportExcel() {
      if (this.filterRates.length) {
        const params = {
          carrier_id: this.form.carriers.id,
          service_id: this.services.rows[this.serviceIndex].id,
          place_id: this.form.places.id,
          carrier_name: this.form.carriers.name,
          places_name: this.form.places.name,
          service_name: this.services.rows[this.serviceIndex].name
        }
        const queryParams = {}
        if (this.form.idSeller) queryParams.organization_id = this.form.idSeller
        this.$store.dispatch('getFiles', { name: 'getFileMixCoverages', params, queryParams })
      }
    },
    cleanFilter() {
      this.rateId = null
      delete this.form.places
      delete this.form.carriers
      delete this.form.categoryService
      this.showTable = false
      this.buttonSend.disabled = true
    },
    getServices(name, params, queryParams) {
      this.$store.dispatch('fetchService', { name, params, queryParams })
    },
    cleanSearch() {
      delete this.destinationForm.destinationPlace
      this.m_setSkeletonField(this.destinationFields, 'name', 'destinationPlace', true)
      setTimeout(() => {
        this.m_setSkeletonField(this.destinationFields, 'name', 'destinationPlace', false)
      })
      this.seekerValue = ''
      this.getCoverages()
    },
    goToCatalog() {
      if (
        this.collectionOnDelivery &&
        this.collectionOnDelivery.rows &&
        this.collectionOnDelivery.rows[0] &&
        Array.isArray(this.collectionOnDelivery.rows[0].limit_services)
      ) {
        const serviceIds = this.collectionOnDelivery.rows[0].limit_services
          .filter(service => service.show_in_catalog)
          .map(service => service.id)
          .join(',')
        const params = {
          country_id: this.form.country.id,
          courier_id: this.form.carriers[0]?.id,
          courier_name: this.form.carriers[0]?.name,
          services: serviceIds
        }
        this.$router.push({ name: 'details-couriers-catalog', query: {showRecaudos: true}, params })
      }
    },
    handleDateSelect() {
      this.buttonFind()
    } 
  }
}
</script>
<style>
.is-disabled {
  background-color: #f8f8f8 !important;
  opacity: 0.5;
}
.form-group-tariffs > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.alertCircle {
    color: white; /* Color del símbolo */
    background: #B3261E;
    border-radius: 50%;
    margin-left: -10px;
    margin-right: 1em;
    width: 18px; /* Ajusta el tamaño del icono */
    height: 18px; /* Ajusta el tamaño del icono */
    margin-top: -5px;
}
.text-services-collections{
  color: rgba(57, 84, 159, 1);
  font-weight: 600;
}
  .link-to-catalog {
    display: flex;
    width: 11rem;
    font-weight: 600;
  }
  .text-link-catalog {
    margin-left: 0.5rem;
  }
.button-destination-search {
  border-radius: 0px ! important;
}
.button-destination-search-close {
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom-left-radius: 0px;
    border-top-left-radius: 0px;
}
</style>
<style lang="css">
  .input-destination-search, .input-destination-search div {
    border-bottom-right-radius: 0px;
    border-top-right-radius: 0px;
  }
</style>